import React from 'react';
import styled from 'styled-components';
import CardLoadingIndicator from './CardLoadingIndicator';
import { ScreenReaderOnly } from '../Shared/SharedStyles';

const RootWrapper = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 30px;
    row-gap: 20px;
`;

const CardGridLoadingIndicator = (props) => (
    <RootWrapper {...props}>
        <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>
        <CardLoadingIndicator shouldAnnounce={false} />
        <CardLoadingIndicator shouldAnnounce={false} />
        <CardLoadingIndicator shouldAnnounce={false} />
        <CardLoadingIndicator shouldAnnounce={false} />
    </RootWrapper>
);

export default CardGridLoadingIndicator;
